"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showKeys = exports.mergeTexts = exports.getConfigWebAndTranslations = exports.getConfigAndTranslations = exports.getTranslations = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const types_1 = require("./types");
const environment_utils_1 = require("../utils/environment.utils");
const emptyTranslation = {
    language: '',
    version: '',
    entries: {},
};
const checkTranslations = (params, translations) => {
    if (!translations || !translations.entries || (0, web_ui_framework_1.isEmpty)(translations.entries)) {
        throw new Error(`Error getting translations in ${params.platform} with language: ${params.baseVersion.language} and version: ${params.baseVersion.version}`);
    }
};
const getTranslations = async (api, params) => {
    try {
        const { platform, baseVersion, translationsServiceHost } = params;
        const translationsManager = new web_ui_framework_1.TranslationsManager({
            provider: new web_ui_framework_1.TranslationsDeltaApi({
                xhr: api,
                getDownloadUrl: versionInfo => `${translationsServiceHost}/v2/internationalization/${platform}/translation/latest`,
            }),
            storage: new web_ui_framework_1.TranslationsWebStorage({ platform }),
            baseVersion,
        });
        const translations = await translationsManager.get();
        checkTranslations(params, translations);
        // checkTranslations check that translations isn't undefined.
        return translations;
    }
    catch (e) {
        console.error(e);
        return emptyTranslation;
    }
};
exports.getTranslations = getTranslations;
const getConfigAndTranslations = async (api, params) => {
    const configParams = { ...params, platform: types_1.TranslationsPlatform.CONFIG };
    const translationsConfigPromise = (0, exports.getTranslations)(api, configParams);
    const translationsPromise = (0, exports.getTranslations)(api, params);
    const [configTranslations, translations] = await Promise.all([translationsConfigPromise, translationsPromise]);
    return {
        configTranslations,
        translations,
    };
};
exports.getConfigAndTranslations = getConfigAndTranslations;
const getConfigWebAndTranslations = async (api, params) => {
    const configParams = { ...params, platform: types_1.TranslationsPlatform.CONFIG };
    const webParams = { ...params, platform: types_1.TranslationsPlatform.WEB };
    const translationsConfigPromise = (0, exports.getTranslations)(api, configParams);
    const translationsPromise = (0, exports.getTranslations)(api, params);
    const translationsWebPromise = (0, exports.getTranslations)(api, webParams);
    const [configTranslations, translations, webTranslations] = await Promise.all([
        translationsConfigPromise,
        translationsPromise,
        translationsWebPromise,
    ]);
    return {
        configTranslations,
        translations,
        webTranslations,
    };
};
exports.getConfigWebAndTranslations = getConfigWebAndTranslations;
const SHOW_KEYS_PARAMS = ['showKeys', 'mostrar-cadenas', 'mostrarCadenas'];
const urlParams = new URLSearchParams(window.location.search);
const isShowKeysQueryPresent = SHOW_KEYS_PARAMS.some(element => urlParams.get(element) === 'true');
/**
 * Merge default translations with overridden translations and return the result.
 * If no overridden translations are passed, return default translations.
 * @param translations - default translations
 * @param overriddenTranslations - optional overridden translations
 * @returns merged translations
 */
const mergeTexts = (translations, overriddenTranslations) => {
    const translationsMerged = overriddenTranslations ? (0, web_ui_framework_1.mergeDeep)(translations, overriddenTranslations) : translations;
    return translationsMerged;
};
exports.mergeTexts = mergeTexts;
exports.showKeys = isShowKeysQueryPresent && (0, environment_utils_1.isPreEnvironment)();
//# sourceMappingURL=helper.js.map